import { format, isSameMonth, isSameDay } from 'date-fns';
import EventPill from './EventPill';

/**
 * CalendarMonthGrid - Desktop month view calendar grid
 */
export default function CalendarMonthGrid({
  calendarDays,
  currentMonth,
  eventsByDay,
  onDayClick,
  getEventDisplayTime,
}) {
  return (
    <div className="card overflow-hidden">
      {/* Week day headers */}
      <div 
        className="grid grid-cols-7"
        style={{ 
          backgroundColor: 'var(--color-bg-surface)',
          borderBottom: '1px solid var(--color-border-subtle)',
        }}
      >
        {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map(day => (
          <div 
            key={day} 
            className="px-2 py-3 text-center text-sm font-semibold" 
            style={{ color: 'var(--color-text-secondary)' }}
          >
            {day}
          </div>
        ))}
      </div>

      {/* Calendar days */}
      <div className="grid grid-cols-7">
        {calendarDays.map((day) => {
          const dayKey = format(day, 'yyyy-MM-dd');
          const dayEvents = eventsByDay[dayKey] || [];
          const isCurrentMonth = isSameMonth(day, currentMonth);
          const isToday = isSameDay(day, new Date());

          return (
            <div
              key={dayKey}
              onClick={() => onDayClick(day, dayEvents)}
              className="min-h-[120px] p-1 cursor-pointer transition-colors"
              style={{ 
                borderBottom: '1px solid var(--color-border-subtle)',
                borderRight: '1px solid var(--color-border-subtle)',
                backgroundColor: !isCurrentMonth ? 'var(--color-bg-soft)' : undefined,
              }}
            >
              {/* Day number */}
              <div 
                className="text-sm font-medium mb-1 w-7 h-7 flex items-center justify-center rounded-full"
                style={{
                  backgroundColor: isToday ? 'var(--color-accent-bg)' : undefined,
                  border: isToday ? '1px solid var(--color-accent-border)' : undefined,
                  color: isToday 
                    ? 'white' 
                    : isCurrentMonth 
                      ? 'var(--color-text-primary)' 
                      : 'var(--color-text-muted)',
                }}
              >
                {format(day, 'd')}
              </div>

              {/* Events */}
              <div className="space-y-0.5">
                {dayEvents.slice(0, 3).map((event, eventIndex) => (
                  <EventPill
                    key={`${event.id}-${eventIndex}`}
                    event={event}
                    displayTime={getEventDisplayTime(event)}
                    compact={true}
                  />
                ))}
                {dayEvents.length > 3 && (
                  <div 
                    className="text-xs font-medium px-1 hover:underline" 
                    style={{ color: 'var(--color-brand-primary)' }}
                  >
                    +{dayEvents.length - 3} more
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
